import React, { useContext, useState } from 'react';
import styled from 'styled-components/macro';
import { Expandable } from '../../../shared/Expandable';
import { ExpandControlChevron } from '../../../shared/ExpandControlChevron';
import { FormContext } from '../../../shared/form/Form';
import { Header2 } from '../../../shared/Headers';
import { Table, TBody, Th, THead, Tr } from '../../../shared/Table';
import { spacing07 } from '../../../styling/spacing';
import { BillOfMaterialsFormHeader } from '../../bill-of-materials/BillOfMaterialsFormHeader';
import { GuidanceTextTemplate } from './dataForViewOrEditQuoteBillOfMaterialsForm';
import { GuidanceTextFormModel } from './viewOrEditQuoteBillOfMaterialsFormModel';
import { GuidanceTextField } from './GuidanceTextField';

type Props = {
  title: string;
  fieldName: string;
  guidanceTextFormModels: Array<GuidanceTextFormModel>;
  guidanceTextTemplatesById: { [guidanceTextTemplateId in number]: GuidanceTextTemplate };
};

export const GuidanceTextFieldSection = ({
  title,
  fieldName,
  guidanceTextFormModels,
  guidanceTextTemplatesById,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { isDisabled } = useContext(FormContext);

  return (
    <Section>
      <BillOfMaterialsFormHeader>
        <ExpandControlChevron isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
        <Header2>{title}</Header2>
      </BillOfMaterialsFormHeader>
      <Expandable isExpanded={isExpanded} animationDurationSeconds={0.5}>
        <Table>
          <THead>
            <Tr>
              <Th />
              <Th />
              <Th />
              <Th />
              <Th>{!isDisabled && 'Customise?'}</Th>
            </Tr>
          </THead>
          <TBody>
            {guidanceTextFormModels.map((guidanceTextFormModel, index) => (
              <Tr key={guidanceTextFormModel.guidanceTextTemplateId}>
                <GuidanceTextField
                  fieldName={`${fieldName}.${index}`}
                  guidanceTextFormModel={guidanceTextFormModel}
                  guidanceTextTemplate={guidanceTextTemplatesById[guidanceTextFormModel.guidanceTextTemplateId]}
                />
              </Tr>
            ))}
          </TBody>
        </Table>
      </Expandable>
    </Section>
  );
};

const Section = styled.div`
  margin: ${spacing07} 0;
`;
